module.exports = __webpack_public_path__ + "img/Skirt-Front-B9-Da-Ha-Ia.7f3be8dd.png";